import React from "react"
import tw from "twin.macro"

const Faqs = (props) => {
    return (
        <section>
            <div css={tw`p-mobile md:p-tablet lg:p-desktop`}>
                <div css={tw`max-w-6xl mx-auto`}>
                    <h2 
                        css={tw`h2 text-center -mt-8 mb-8`} 
                        dangerouslySetInnerHTML={{
                        __html: props.title,
                    }}
                    ></h2>
                    <ul
                        css={tw`mt-4 list-none p-0 grid grid-cols-1 md:grid-cols-2 col-gap-20`}
                        css={props.singleCol ? tw`md:grid-cols-1` : tw`grid grid-cols-1 md:grid-cols-2 col-gap-20`}
                    >
                        {props.questions.map((question, index) => (
                            <li key={index} css={tw``}>
                                <div css={tw`flex justify-between py-2`}>
                                    <h3
                                        css={tw`font-semibold text-lg`}
                                        dangerouslySetInnerHTML={{
                                            __html: question.q,
                                        }}
                                    ></h3>
                                </div>
                                <div
                                    css={tw`mb-4 text-sm`}
                                    dangerouslySetInnerHTML={{
                                        __html: question.a,
                                    }}
                                ></div>{" "}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    )
}

Faqs.defaultProps = {
    title: "Questions fréquemment posées",
}

export default Faqs
